import { useState } from "react";

import {
  Box,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";

import SaveIconSvg from "@/assets/svg/save-list-icon.svg";
import ViewIcon from "@/assets/svg/view-icon.svg";

import AddModal from "../../shared/AddModal";
import PreferenceButton from "../../shared/PreferenceButton";
import ViewPreferenceItem from "../../shared/ViewPreferenceItem";
import AddViewItem from "../../viewMenu/AddViewItem";
import ViewMenuItem from "../../viewMenu/ViewMenuItem";


const SaveMenu = ({ listData, listHandler, onOpenMenuHandler }) => {
  const [isAdd, setIsAdd] = useState(false);
  const saveMenuControl = useDisclosure();
  const onCloseHandler = () => {
    setIsAdd(false);
  };

  return (
    <Menu isOpen={saveMenuControl.isOpen} onClose={saveMenuControl?.onClose}>
      {({ onClose }) => (
        <>
          <PreferenceButton handler={() => setIsAdd(false)}>
            <MenuButton
              onClick={() => onOpenMenuHandler(saveMenuControl.onOpen)}
            >
              <ViewPreferenceItem title={"Save as"} icon={SaveIconSvg} />
            </MenuButton>
          </PreferenceButton>
          <MenuList
            w={{ base: "100%", sm: "327px" }}
            maxW={"327px"}
            py={"12px"}
            border={"none"}
            zIndex={"1000"}
            boxShadow={"0px 0px 20px 5px #80808040"}
          >
            {!isAdd ? (
              <>
                <AddViewItem
                  isView={true}
                  handler={() => setIsAdd(true)}
                  isTagMenu={false}
                />

                {listData?.length ? (
                  <Box
                    borderBottomWidth={"1px"}
                    borderColor={"lightGray"}
                    mx={"12px"}
                    my={"8px"}
                  />
                ) : null}
                <Flex direction={"column"} rowGap={"8px"}>
                  {listData?.map((item, index) => (
                    <ViewMenuItem
                      key={item?.id}
                      item={item}
                      index={index}
                      isView={true}
                      icon={ViewIcon}
                      onClose={onClose}
                      handler={() => listHandler(item)}
                      isDelete={false}
                    />
                  ))}
                </Flex>
              </>
            ) : (
              <Flex p={"12px"}>
                <AddModal
                  isView={true}
                  title={"Add view"}
                  onClose={onCloseHandler}
                />
              </Flex>
            )}
          </MenuList>
        </>
      )}
    </Menu>
  );
};

export default SaveMenu;
